export default __webpack_public_path__ + "static/media/angular.767fd07b.svg";